import { ReportType } from '../../graphql/schema/p4types';

enum Source {
  Customer,
  Supplier,
  Product,
  Internal,
}

type SourceType = {
  sourceType: Source;
  label: string;
};

export const sourceTypes = {
  customer: {
    sourceType: Source.Customer,
    label: 'Customer',
  },
  supplier: {
    sourceType: Source.Supplier,
    label: 'Supplier',
  },
  product: {
    sourceType: Source.Product,
    label: 'Product',
  },
  internal: {
    sourceType: Source.Internal,
    label: 'Internal',
  },
} as const;

type DocumentSource = {
  sourceType: SourceType;
  reportType: ReportType;
};

const documentSources: Array<DocumentSource> = [
  {
    sourceType: sourceTypes.customer,
    reportType: ReportType.SalesAcknowledgement,
  },
  {
    sourceType: sourceTypes.supplier,
    reportType: ReportType.DebitNote,
  },
  {
    sourceType: sourceTypes.product,
    reportType: ReportType.ProductLabel,
  },
  {
    sourceType: sourceTypes.customer,
    reportType: ReportType.SalesPickingList,
  },
];

export const findDocumentSource = (reportType: ReportType) => {
  return documentSources.find((value) => value.reportType === reportType)?.sourceType;
};
